/*
 * @Author: your name
 * @Date: 2021-06-03 14:48:55
 * @LastEditTime: 2023-10-18 19:36:28
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-mall\service\index.js
 */

import axios from 'axios';
// import { createApp } from '@/.'
// import Router from 'vue-router'
// import qs from 'qs'
import config from './config';

// if (process.server) {
//   config.baseURL =  process.env.baseUrl;
// }
// axios.defaults.baseURL = process.env.baseUrl;
const service = axios.create(config);
// console.log(process.env.API_URL)
// 正在进行中的请求列表
const reqList = [];

/**
 * 阻止重复请求
 * @param {array} reqList - 请求缓存列表
 * @param {string} url - 当前请求地址
 * @param {function} cancel - 请求中断函数
 * @param {string} errorMessage - 请求中断时需要显示的错误信息
 */
const stopRepeatRequest = function (reqList, url, cancel, errorMessage) {
  const errorMsg = errorMessage || '';
  for (let i = 0; i < reqList.length; i++) {
    if (reqList[i] === url) {
      cancel(errorMsg);
      return;
    }
  }
  reqList.push(url);
};

/**
 * 允许某个请求可以继续进行
 * @param {array} reqList 全部请求列表
 * @param {string} url 请求地址
 */
const allowRequest = function (reqList, url) {
  for (let i = 0; i < reqList.length; i++) {
    if (reqList[i] === url) {
      reqList.splice(i, 1);
      break;
    }
  }
};

function getCookie(name) {
  // 获取指定名称的cookie值
  // (^| )name=([^;]*)(;|$),match[0]为与整个正则表达式匹配的字符串，match[i]为正则表达式捕获数组相匹配的数组；
  const arr = document.cookie.match(new RegExp(`(^| )${name}=([^;]*)(;|$)`));
  if (arr != null) {
    return unescape(arr[2]);
  }
  return null;
}

// POST 传参序列化
service.interceptors.request.use(
  (config) => {
    // let token= window.$nuxt.$cookies.get('epecToken')
    // let token= 'eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJlcGVjSnd0IiwiaXNzIjoiZXBlYy5jb20iLCJhdWQiOiJ3ZWItcGFnZSIsImlhdCI6MTYyNDA4Nzk2NCwic3ViIjoiVndwOE4wM0Q0dmp2Sy9YelNsWjFMN01abGxTMHBnaDIiLCJleHAiOjE2MjQwOTE1NjR9.YsSjQeMpS24JT9AvIB_yKprqW0SdaWR1zsZqdjBOoXs'
    // let token = this.$cookies.get('epecToken')
    const token = getCookie('epecToken');
    const headers = {
      'Content-Type': 'application/json',
      'epec-from': 'PURCHASE_WEB_SITE',
      'epec-locale': 'ZH',
    };
    if (token) {
      config.headers = {
        ...headers,
        'epec-sso-token': token,
      };
    } else {
      config.headers = {
        ...headers,
        'epec-sso-token': '',
      };
    }

    // // if (config.method === 'post') config.data = qs.stringify(config.data)
    // let cancel
    // // 设置cancelToken对象
    // config.cancelToken = new axios.CancelToken(function(c) {
    // 	cancel = c
    // })
    // // 阻止重复请求。当上个请求未完成时，相同的请求不会进行
    // stopRepeatRequest(reqList, config.url, cancel, `${config.url} 请求被中断`)

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 返回状态判断
service.interceptors.response.use(
  (res) => {
    setTimeout(() => {
      allowRequest(reqList, res.config.url);
    }, 1000);
    if (res.data.code == 401) {
      $nuxt._router.push({ path: '/ssologin' });
    }
    // else if(res.data.code==500){
    //   $nuxt.$message({
    //     message: res.message,
    //     type: 'error'
    //   });
    //   return
    // }
    else {
      return res.data;
    }
  },
  (error) => {
    // redirect('/login')
    // console.log('error11111=',error.response.status)
    // if (axios.isCancel(error)) {
    //   console.log(error.message);
    // } else {
    //   // 增加延迟，相同请求不得在短时间内重复发送
    //   setTimeout(() => {
    //     allowRequest(reqList, error.config.url)
    //   }, 1000)
    // }
    // console.log($nuxt)
    if (error.response.status == 401) {
      $nuxt._router.push({
        path: '/ssologin',
      });
      return;
    }
    // if (error.response.status == 500) {
    //   $nuxt.$message({
    //     message: res.message,
    //     type: 'error'
    //   });
    //   return
    // }
    return Promise.reject(error);
  }
);

export default service;
